module.exports = __webpack_public_path__ + "static/media/2_elephant_horse.0f2f1e97.png";